module.exports = __webpack_public_path__ + "img/sad_smile.fe6439d0.svg";